<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <RealEstateSelectFilter :clearable="false" :fetchData="fetchMovementsAsAdmin" />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterDates :fetchData="fetchMovementsAsAdmin" :dateRange="true" />
    </v-col>
  </v-row>
</template>

<script>
import FilterDates from '@/components/filters/FilterDates'
import RealEstateSelectFilter from '../../../components/realEstate/RealEstateSelectFilter.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AdminMovementListFilter',

  components: { FilterDates, RealEstateSelectFilter },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapActions(['fetchMovementsAsAdmin']),
  },
}
</script>
